import { differenceInMinutes } from 'date-fns';

import { Tag } from './TimeDifferenceTag.styles';

const EARLY = 'early';
const DELAY = 'delay';

interface ITimeDifferenceTag {
  timeA: Nullable<Date>;
  timeB: Nullable<Date>;
}

export const TimeDifferenceTag = ({ timeA, timeB }: ITimeDifferenceTag) => {
  if (!timeA || !timeB) {
    return null;
  }
  const diff = differenceInMinutes(new Date(timeA), new Date(timeB));
  const status = getStatus(diff);

  if (!status) {
    return null;
  }

  return <Tag status={status}>{`${Math.abs(diff)} min ${status}`}</Tag>;
};

const getStatus = (time) => {
  if (time < 0) {
    return EARLY;
  }
  if (time > 0) {
    return DELAY;
  }

  return null;
};
